import * as React from "react"

import { Symbols } from "@tenforce/toolbox-fontmap"

import Thumbnail from "../../common/Thumbnail"
import bem from "../../../bem"

export const className = "toolbox-attachment"
const b = bem.with(className)

interface Props {
    attachment: InlineAttachments.Attachment
    index: number
    onAttachmentLoad?: () => void
    showLightbox: (index: number) => void
    wrapperClasses: string
}

export default class AttachmentCard extends React.PureComponent<Props> {
    private fileNameRegex = /(.*)\.(?=[^\\.]+$)(.*)/

    componentDidMount(): void {
        const {
            onAttachmentLoad,
            attachment: { thumbnail },
        } = this.props

        // count the non-image attachments already
        if (!thumbnail && !!onAttachmentLoad) {
            onAttachmentLoad()
        }
    }

    render(): JSX.Element {
        const { attachment, wrapperClasses, showLightbox, index } = this.props
        const fullName = this.fileNameRegex.exec(attachment.fileName) ?? [
            "",
            "",
        ]
        const fileName = fullName[1]
        const fileExtension = `.${fullName[2]}`

        return (
            <div
                className={`${wrapperClasses} ${b("cardWrapper")}`}
                key={attachment.key}
                data-ft-attachment-card
                data-ft-attachment-name={attachment.fileName}
                data-ft-attachment-description={attachment.description ?? ""}
            >
                <button
                    className={b("button")}
                    onClick={(event: React.MouseEvent): void => {
                        event.preventDefault()
                        showLightbox(index)
                    }}
                >
                    <div className="absolute-container">
                        <div
                            className={`${b()} full-size ${
                                !attachment.thumbnail && "bg-cloud"
                            }`}
                        >
                            <div className={b("cover")}>
                                {attachment.thumbnail ? (
                                    <Thumbnail
                                        lowResSrc={attachment.thumbnail}
                                        hiResSrc={attachment.url}
                                        alt={attachment.fileName}
                                        onLoad={this.onLoad}
                                    />
                                ) : (
                                    <>
                                        <div className="h3 text-action">
                                            {Symbols.Item}
                                        </div>
                                        <div
                                            className={`${b(
                                                "fileName",
                                            )} label text-action`}
                                            data-ft-name
                                        >
                                            {fileName}
                                        </div>
                                        <div className="label is-dimmed">
                                            {fileExtension}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </button>
            </div>
        )
    }

    onLoad = (): void => {
        const { onAttachmentLoad } = this.props
        if (!!onAttachmentLoad) {
            onAttachmentLoad()
        }
    }
}
